export default __webpack_public_path__ + "static/media/Group 5789@2x.758ba21a.png";